import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { HeaderComponent } from './component/header/header.component';
import { FooterComponent } from './component/footer/footer.component';
import {
  RouterOutlet,
  Router,
  NavigationEnd,
  RouterModule,
} from '@angular/router';
import { NavbarComponent } from './component/navbar/navbar.component';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { filter } from 'rxjs/operators';
import { LoaderComponent } from './component/loader/loader.component';

@Component({
  selector: 'app-root',
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    RouterOutlet,
    HeaderComponent,
    NavbarComponent,
    FooterComponent,
    CommonModule,
    MatSnackBarModule,
    LoaderComponent,
  ],
  templateUrl: './app.component.html',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  styleUrls: ['./app.component.less'],
})
export class AppComponent implements OnInit {
  title = 'PnaWeb';
  currentUser: any[] = [];
  showHeaderFooter = true;
  isLoading = false;

  constructor(private readonly router: Router) {}

  ngOnInit() {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.showHeaderFooter =
          !event.url.includes('/user-select-email') &&
          !event.url.includes('/user-select-qa') &&
          !event.url.includes('/user-select-cai');
      });
  }
}
